var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666656,
    width: 42.6975,
    height: 40,
    rx: 6.95652,
    fill: "#F6F5DA",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2909 6.95654H34.7052L25.0624 18.0057L36.4076 33.0435H27.5256L20.5638 23.925L12.607 33.0435H8.18858L18.5016 21.2213L7.62317 6.9586H16.7314L23.0146 15.2917L30.2909 6.95654ZM28.7386 30.3953H31.1853L15.395 9.46696H12.7715L28.7386 30.3953Z",
    fill: "#F8F7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconX);
export default __webpack_public_path__ + "static/media/IconX.1334188f7cf7d76a576dad138cfec0fd.svg";
export { ForwardRef as ReactComponent };